import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {khanmigoToolsGetBlooketQuestionSetType} from "./__graphql-types__/index.ts";

export const GET_BLOOKET_QUESTION_SET: GqlOperation<
    khanmigoToolsGetBlooketQuestionSetType["response"],
    khanmigoToolsGetBlooketQuestionSetType["variables"]
> = gqlOp(gql`
    query khanmigoToolsGetBlooketQuestionSet($threadId: String!) {
        blooketQuestionSet(threadId: $threadId) {
            id
            ownerKaid
            threadId
            title
            description
            questions {
                text
                timeLimit
                randomizeAnswers
                answers {
                    text
                    isCorrect
                }
            }
        }
    }
`);
